import { AnimateOnScrolledTo } from '@web/components/AnimateOnScrolledTo'

type QuoteSectionProps = {
  quote: string
  name: string
  title: string
}

export default function QuoteSection({ quote, name, title }: QuoteSectionProps) {
  return (
    <section className="bg-neutral-muted py-16 md:py-24">
      <div className="flex mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-[3fr_4px_1fr] gap-4 items-start">
          <AnimateOnScrolledTo
            from={{ opacity: 0.2 }}
            to={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
            className="flex flex-col items-end md:pr-4 relative"
          >
            <div className="absolute -top-2 left-0 text-7xl leading-none text-brand-blue">"</div>
            <blockquote className="text-base italic text-right pl-6 pr-6">{quote}</blockquote>
            <div className="absolute -bottom-2 right-1 text-7xl leading-none text-brand-blue rotate-180">
              "
            </div>
          </AnimateOnScrolledTo>
          <div className="min-w-1 h-full rounded-full bg-brand-blue" />
          <AnimateOnScrolledTo
            from={{ opacity: 0, x: -16 }}
            to={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.8 }}
            className="flex flex-col items-start md:pl-4"
          >
            <span className="text-lg font-semibold text-brand-blue">{name}</span>
            <AnimateOnScrolledTo
              from={{ opacity: 0, x: -16 }}
              to={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 1.2 }}
            >
              <span className="text-base text-brand-blue">{title}</span>
            </AnimateOnScrolledTo>
          </AnimateOnScrolledTo>
        </div>
      </div>
    </section>
  )
}
